<template>
    <div class="spaceBetween">
        <a-date-picker
        style="width:45%"
        v-model="startValue"
        :disabled="disabled"
        :disabled-date="disabledStartDate"
        format="YYYY-MM-DD"
        placeholder="请选择"
        valueFormat="YYYY-MM-DD"
        />
        ~
        <a-date-picker
        style="width:45%"
        :showToday="false"
        :disabled="disabled"
        v-model="endValue"
        :disabled-date="disabledEndDate"
        format="YYYY-MM-DD"
        :placeholder="endDatePlace||'请选择'"
        :open="endOpen"
        valueFormat="YYYY-MM-DD"
        @openChange="handleEndOpenChange"
        >
            <template slot="renderExtraFooter">
                <div style="text-align:center;"><a @click="setEndDateNone()">长期</a></div>
            </template>
        </a-date-picker>
    </div>
</template>

<script>

    export default {
        props:["disabled"],
        name:"startEndDate",
        data() {
            return {
                startValue:undefined,
                endValue:undefined,
                endDatePlace:'',
                endOpen:false
            };
        },
        methods: {
            // 起止日期选择
            disabledStartDate(startValue) {
                const endValue = this.endValue;
                if (!startValue || !endValue) {
                    return false;
                }
                return startValue.valueOf() > endValue.valueOf();
            },
            disabledEndDate(endValue) {
                const startValue = this.startValue;
                if (!endValue || !startValue) {
                    return false;
                }
                return startValue.valueOf() >= endValue.valueOf();
            },
            setEndDateNone(){
                this.endValue = "";
                this.endDatePlace = "长期"
                this.handleEndOpenChange(false);
            },
            handleStartOpenChange(open) {
                if (!open) {
                    this.endOpen = true;
                }
            },
            handleEndOpenChange(open) {
                this.endOpen = open;
            },
            getVal(){
                return {
                    startValue:this.startValue,
                    endValue:this.endValue
                }
            },
            setVal(startValue,endValue){
                this.startValue = startValue;
                this.endValue = endValue == "长期" ? "" : endValue;
                this.endDatePlace = "长期";
            }
        }
    }
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ui/startEndDate.vue